import z from '@/lib/zod';
import { commonSearchSchema } from './commonSearchSchema';
import { optionalSearchString } from './search-param-schemas';

/**
 * Consumi per tenant (lista + dettaglio `$tenantId`): tab di livello su
 * `subTab`, ricerca e ordinamento. Validato dal layout per lista e dettaglio.
 */
export const serviceUsageSearchSchema = commonSearchSchema.extend({
  /** Tab Tutti / Oltre 80% / Al limite (`SERVICE_USAGE_TABS`). */
  subTab: optionalSearchString(),
});

export type ServiceUsageSearch = z.output<typeof serviceUsageSearchSchema>;

/**
 * Vista per tipo di servizio: SOLO azienda, anno e mese, le chiavi che
 * `by-service-type` accetta. Senza lo schema comune: i suoi default di
 * `skip`/`take` finivano nell'URL a ogni filtro (SU-4), per un endpoint che
 * non pagina.
 */
export const serviceUsageByServiceSearchSchema = z.object({
  tenantId: optionalSearchString(),
  year: optionalSearchString(),
  month: optionalSearchString(),
});

export type ServiceUsageByServiceSearch = z.output<
  typeof serviceUsageByServiceSearchSchema
>;
